/**
 * Controls reference — a static cheat sheet reached from the ESC menu.
 * Grouped by context; content is data so new binds are one-line adds.
 */

const SECTIONS: { title: string; binds: [string, string][] }[] = [
  {
    title: "FLIGHT",
    binds: [
      ["MOUSE", "steer (the pip reticle leads the nose)"],
      ["W / S", "throttle up / down"],
      ["A / D", "roll"],
      ["SPACE / X", "thrusters — climb / descend"],
      ["Z", "cut throttle"],
      ["SHIFT", "boost"],
      ["R", "pulse drive · hold to charge hyperlight on a set course"],
      ["R ×2", "on an aimed star: set course + charge in one motion"],
      ["N", "set course to the aimed star"],
      ["LMB / RMB", "fire weapon groups"],
      ["G (HOLD)", "mining beam (near a vein)"],
      ["F", "interact — disembark, board, join a wormhole"],
    ],
  },
  {
    title: "ON FOOT",
    binds: [
      ["W A S D", "move (camera-relative)"],
      ["SHIFT (HOLD)", "sprint on the ground or wall"],
      ["WALL RUN", "run or sprint alongside a wall · 2.5 s max · tap Space kicks off · release forward to slow and fall"],
      ["LEDGE CATCH", "keep moving toward a reachable ledge while airborne to climb onto it · X or backward releases"],
      ["SPACE (TAP)", "jump · second tap double-jumps · third tap launches flight with a free 0.8 s boost"],
      ["SPACE (TAP)", "while flying: settle into hover"],
      ["SHIFT (HOLD)", "while flying: boost using energy · release to glide"],
      ["GLIDING", "look to steer · A/D bank · S brake · energy refills on ground"],
      ["X", "crouch (grounded) · hold high in the air to dive"],
      ["Q / E", "previous / next owned weapon · 1–0 selects directly"],
      ["RMB (HOLD)", "unarmed: aim-walk (hold Shift to sprint) · cannon: aim · blade: focus"],
      ["LMB", "cannon: fire · blade: strike (combo) — both spend ENERGY"],
      ["G (HOLD)", "mine (near a vein)"],
      ["V", "tap: summon / stow vehicle · hold: summon ship"],
      ["F", "interact — board ship · board vehicle"],
    ],
  },
  {
    title: "VEHICLE",
    binds: [
      ["MOUSE / A D", "steer · bank while gliding"],
      ["W / S", "throttle / reverse on the ground"],
      ["RMB (HOLD)", "handbrake drift"],
      ["SPACE", "detach from ground and deploy glide surfaces"],
      ["W + SHIFT", "boost on the ground or while gliding"],
      ["LMB", "fire vehicle weapons"],
      ["F", "exit vehicle"],
    ],
  },
  {
    title: "EVERYWHERE",
    binds: [
      ["TAB", "companion menu — atlas, inventory, journal, nearby signals"],
      ["C (HOLD)", "action wheel — flick a quadrant and release"],
      ["C → LEFT", "navigate (galactic chart)"],
      ["C → RIGHT", "inventory + fabricator"],
      ["ESC", "menu (the world does not pause)"],
    ],
  },
];

export class ControlsPanel {
  visible = false;
  private el: HTMLElement;

  constructor(private handlers: { onClose: () => void }) {
    this.el = document.createElement("div");
    this.el.id = "controls-panel";
    this.el.style.display = "none";
    const sections = SECTIONS.map(
      (sec) => `
      <div class="cp-section">
        <div class="cp-sec-title">${sec.title}</div>
        ${sec.binds.map(([k, what]) => `<div class="cp-row"><kbd>${k}</kbd><span>${what}</span></div>`).join("")}
      </div>`,
    ).join("");
    this.el.innerHTML = `
      <div class="cp-panel">
        <div class="cp-title">CONTROLS</div>
        <div class="cp-grid">${sections}</div>
        <button class="cp-close" id="cp-close">BACK (esc)</button>
      </div>
    `;
    document.body.appendChild(this.el);
    this.el.querySelector("#cp-close")!.addEventListener("click", () => this.close());
  }

  open(): void {
    this.visible = true;
    this.el.style.display = "flex";
  }

  close(): void {
    if (!this.visible) return;
    this.visible = false;
    this.el.style.display = "none";
    this.handlers.onClose();
  }
}
